import { TFunction } from 'i18next'
import { Dayjs } from 'dayjs'
import List from './List'
import Statistical from './Statistical'

export const tabs = (
    t: TFunction,
    filterTime: [Dayjs | null, Dayjs | null]
) => [
    {
        label: t('statistical'),
        value: 'statistical',
        component: <Statistical filterTime={filterTime} />,
    },
    {
        label: t('ticket-list'),
        value: 'list',
        component: <List filterTime={filterTime} />,
    },
]
